import UIButton from 'UIComponents/button/UIButton';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { useCurrentView } from '../../custom-views/hooks/useCurrentView';
import { isFilteredView, isTrashView } from 'find-and-filter-data/views-schema/public';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const UnknownVisitorInfo = ({
  openAssociateModal
}) => {
  const currentView = useCurrentView();
  return /*#__PURE__*/_jsxs("div", {
    className: "justify-between flex-wrap flex-grow-1",
    "data-test-id": "unknown-contact-info-highlight",
    children: [/*#__PURE__*/_jsx(FormattedMessage, {
      message: "conversations-inbox-ui.unknownVisitor",
      className: "m-right-2"
    }), /*#__PURE__*/_jsx(UIButton, {
      "data-test-id": "associate-unknown-visitor-button",
      disabled: isFilteredView(currentView) || isTrashView(currentView),
      onClick: openAssociateModal,
      use: "tertiary",
      size: "extra-small",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "conversations-inbox-ui.contactPrompt.header"
      })
    })]
  });
};
UnknownVisitorInfo.displayName = 'UnknownVisitorInfo';
export default UnknownVisitorInfo;